import { createStart, createMiddleware } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";

import { renderErrorPage } from "./lib/error-page";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    // Server function RPC requests need TanStack's own error serialization
    // (seroval framed response). Swallowing the throw here and returning
    // an HTML error page breaks the client-side deserializer, which then
    // surfaces as `Cannot read properties of undefined (reading 'bind')`
    // inside seroval's ShallowErrorPlugin.
    let pathname = "";
    try {
      const req = getRequest();
      if (req?.url) pathname = new URL(req.url, "http://x").pathname;
    } catch {
      /* ignore */
    }
    if (pathname.startsWith("/_serverFn/")) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [errorMiddleware],
}));
